import { useEffect } from 'react';

declare global {
    interface Window {
        _kiq?: unknown[];
    }
}

const QUALAROO_URL_FOR_DOMAINS = {
    AU: 'https://cl.qualaroo.com/ki.js/46060/jKB.js',
    CA: 'https://cl.qualaroo.com/ki.js/46060/jUe.js',
    COM: 'https://cl.qualaroo.com/ki.js/46060/dm7.js',
    UK: 'https://cl.qualaroo.com/ki.js/46060/jFE.js',
    LOCAL: 'https://cl.qualaroo.com/ki.js/46060/jJ9.js',
};

function getQualarooSourceUrl() {
    const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
    if (hostname === 'localhost') {
        return QUALAROO_URL_FOR_DOMAINS.LOCAL;
    }
    const domain = hostname.split('.').pop()?.toUpperCase();

    if (domain && domain in QUALAROO_URL_FOR_DOMAINS) {
        return QUALAROO_URL_FOR_DOMAINS[domain as keyof typeof QUALAROO_URL_FOR_DOMAINS];
    }
    return QUALAROO_URL_FOR_DOMAINS.COM;
}

function QualarooLoader() {
    useEffect(() => {
        if (document.getElementById('qualaroo-script')) {
            return;
        }

        window._kiq = window._kiq || [];

        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.id = 'qualaroo-script';
        script.setAttribute('data-testid', 'qualaroo-script');
        script.src = getQualarooSourceUrl();

        document.body.appendChild(script);
    }, []);

    return null;
}

export { QualarooLoader };
